import {useEffect, useState} from "react";
import valuer_api from "../../api/valuer";
import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";

const ValuerAmendIntegerInput = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Optional
    const field = props.field
    const placeholder = props.placeholder ? props.placeholder : ""
    const fieldInfo = props.fieldInfo
    const infoColor = props.infoColor ? props.infoColor : "#000000"
    const defaultValue = props.defaultValue ? props.defaultValue : ""
    const flex = props.flex ? props.flex : false
    const rowId = props.rowId ? props.rowId : false

    // Sizing
    const width = props.width ? props.width : '100%'
    const height = props.height ? props.height : '100%'
    const minHeight = props.minHeight ? props.minHeight : '48px'
    const minWidth = props.minWidth ? props.minWidth : '0'

    // Value
    const [value, setValue] = useState("")

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.value !== undefined) {
            if (props.value === null && defaultValue) setValue(defaultValue)
            else setValue(props.value)
        }
    }, [props.value, defaultValue])


    const UpdateValue = () => {
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let body = { "value": value}
        if (rowId) body["row"] = rowId
        UpdateParentValue(identifier, value, rowId)
        let response = valuer_api.ValuerAmendPut(summaryId, section, identifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, identifier, updateTime)
            }
        ).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime)
            setErrorTitle("Failed to Save")
            setErrorMessage("The request to save a field has failed")
        })
    }

    const ClickOff = () => {
        // Check for required fields and then submit change
        if (!summaryId || !section || !identifier) return
        UpdateValue()
    }

    return (
        <>
            <div className={"valuer-amend-free-text-field-container"  + (flex ? ' inline' : '')}
                 style={width !== '100%' ? {width: width, minWidth: minWidth} : {width: width, minWidth: minWidth, overflow: 'hidden'}}>
                {field && field
                    ? <div className="valuer-amend-field-label"> {field} </div>
                    : null
                }
                {fieldInfo && fieldInfo
                    ? <div className="valuer-amend-field-info" style={{color: infoColor}}> {fieldInfo} </div>
                    : null
                }
                <div className="valuer-amend-field-input-container"
                     style={{width: width, height: height, minHeight: minHeight, minWidth: minWidth}}>
                    <textarea placeholder={placeholder} value={value} className="valuer-amend-field"
                              onChange={(ev) => {
                                  let _value = ev.target.value
                                  _value = _value.replace(new RegExp(",", "g"), "").replace("£", "")
                                  if (parseInt(_value)) {
                                      if (field === "Year build") {
                                          _value = parseInt(_value);
                                      } else {

                                          _value = parseInt(_value).toLocaleString();
                                      }
                                  } else {
                                      _value = ""
                                  }
                                  setValue(_value)
                              }}
                              onBlur={() => ClickOff()} defaultValue={defaultValue}/>

                </div>
            </div>
        </>
    )

}

export default ValuerAmendIntegerInput